import { gql } from '@apollo/client';

export const QueryCompanyEntitiesUserGroups = gql`
	query QueryCompanyEntities($companyId: ID!) {
		queryCompanyEntities(companyId: $companyId) {
			companyId
			userGroups {
				id
				name
			}
		}
	}
`;

export const GetCompanyAnnouncementsSettings = gql`
	query GetCompany($id: ID!) {
		getCompany(id: $id) {
			id
			announcementsSettings {
				headerTitle
				headerSubtext
				accentColor
				pinnedColor
				gradientStart
				gradientMid
				gradientEnd
				showAuthor
				showCount
				showViews
				defaultAuthor
			}
		}
	}
`;

export const UpdateCompanyAnnouncementsSettings = gql`
	mutation UpdateCompany($input: UpdateCompanyInput!) {
		updateCompany(input: $input) {
			id
			announcementsSettings {
				headerTitle
				headerSubtext
				accentColor
				pinnedColor
				gradientStart
				gradientMid
				gradientEnd
				showAuthor
				showCount
				showViews
				defaultAuthor
			}
		}
	}
`;

export const IncrementAnnouncementViewCount = gql`
	mutation IncrementAnnouncementViewCount($id: ID!) {
		incrementAnnouncementViewCount(id: $id) {
			id
			viewCount
		}
	}
`;

export const QueryAnnouncementsTagsByCompanyId = gql`
	query QueryAnnouncementsTagsByCompanyId($companyId: ID!) {
		queryAnnouncementsTagsByCompanyId(companyId: $companyId)
	}
`;

export const queryAnnouncements = gql`
	query QueryAnnouncements(
		$userId: ID!
		$overrideRole: Boolean
		$search: String
		$sortBy: String
		$tags: [String]
		$first: Int!
		$after: String
	) {
		queryAnnouncements(
			userId: $userId
			overrideRole: $overrideRole
			search: $search
			sortBy: $sortBy
			tags: $tags
			first: $first
			after: $after
		) {
			items {
				id
				companyId
				title
				content
				dateCreated
				hide
				userGroups
				thumbnail {
					bucket
					key
					region
				}
				displayGroupSelect
				tags
				pinned
				author
				thumbnailSignedUrl
				publishAt
				expireAt
				viewCount
				updatedAt
			}
			totalCount
			nextToken
		}
	}
`;
